import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectConfigureAccountDomain = function (configureAccount) {
    return (configureAccount && configureAccount.configureAccount) || getInitialState();
};
export var selectConfigureAccount = createSelector(selectConfigureAccountDomain, function (configureAccount) { return configureAccount; });
export var selectCurrentStep = createSelector(selectConfigureAccountDomain, function (configureAccount) { return configureAccount.step; });
export var selectDevPlans = createSelector(selectConfigureAccountDomain, function (configureAccount) {
    var _a;
    return (_a = configureAccount === null || configureAccount === void 0 ? void 0 : configureAccount.devPlans) === null || _a === void 0 ? void 0 : _a.filter(function (plan) { return plan.interval === configureAccount.devPlanInterval; });
});
